import React from 'react';
import { TextV2 } from '@withjoy/joykit';
import { SummarySection } from '@shared/components/SummaryCard/SummarySection';
import { GuestInfo } from '@shared/components/EventForm/components/presentational/hooks/useEventFormNav';
import { useTranslation } from '@shared/core/i18n/useTranslation';

type GuestNameSummaryProps = {
  guestInfo: GuestInfo;
};

export const GuestNameSummary = ({ guestInfo }: GuestNameSummaryProps) => {
  const { tq } = useTranslation('eventFormDisplay');

  return (
    <SummarySection title={tq`Guest Name`}>
      <TextV2
        typographyVariant="body1"
        color="mono11"
      >
        {guestInfo.guestDisplayName}
      </TextV2>
    </SummarySection>
  );
};
